const URL_MARKER = '/image/upload/';
/**
 * Based on the properties of the retina display
 * it is better to use x2 the size of the displayed image using CSS to maintain image quality.
 */
const IMAGE_SIZES = {
  // Dashboard UI profiles sizes
  dashboardMembersList: { width: 120, height: 120 },
  dashboardProfileDetails: { width: 240, height: 240 },
  dashboardProfileNavigation: { width: 72, height: 72 },

  // Dashboard UI organizations sizes
  dashboardOrganizationsList: { width: 240, height: 240 },
};

const isCloudinaryUploadUrl = url => url.includes('res.cloudinary.com') && url.includes(URL_MARKER);

const buildAvatarQuery = ({ width, height }, useFaceCentric) => {
  let query = `w_${width},h_${height},f_auto,q_auto,dpr_auto,c_fit`;
  if (useFaceCentric) query += ',c_thumb,g_face';

  return query;
};

function transformCloudinaryImageUrl(url, transform) {
  if (!url || !isCloudinaryUploadUrl(url)) return url;

  const markerIndex = url.indexOf(URL_MARKER);
  if (markerIndex === -1) return url;

  const prefix = url.slice(0, markerIndex + URL_MARKER.length);
  const rest = url.slice(markerIndex + URL_MARKER.length);
  const firstSegment = rest.split('/')[0] ?? '';
  const alreadyHasTransform = firstSegment.length > 0 && !/^v\d+$/.test(firstSegment);

  if (alreadyHasTransform) return url;
  return `${prefix}${transform}/${rest}`;
}

function getAvatarUrl(originalUrl, size, useFaceCentric = true) {
  if (!originalUrl) return undefined;
  return transformCloudinaryImageUrl(originalUrl, buildAvatarQuery(size, useFaceCentric));
}
export default {
  getAvatarUrl,
  IMAGE_SIZES,
};
